import React from "react";

const ContentBlock = (props) => {
  let classes = "content-block";
  if (props.whiteBg) {
    classes += " white-bg";
  }
  if (props.noBottomSpacing) {
    classes += " no-btm";
  }
  if (props.noTopSpacing) {
    classes += " no-top";
  }
  return (
    <div className={classes} id={props.id}>
      <div className="inner-center">{props.children}</div>
    </div>
  );
};
export default ContentBlock;
